import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useNotification } from "@mmfestival/shared-components";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../lib/firebase";

export const AdminRoute = () => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const checkRole = async () => {
      if (loading) return;
      
      if (!user) {
        setUserRole(false);
        return;
      }

      try {
        // Check Firestore only
        const userDocRef = doc(db, "users", user.uid);
        const userDoc = await getDoc(userDocRef);
        
        if (userDoc.exists()) {
          const dbRole = userDoc.data().role;
          if (dbRole === "admin" || dbRole === "rpc") {
            setUserRole(dbRole);
          } else {
            setUserRole(false);
          }
        } else {
          setUserRole(false);
        }
      } catch (error) {
        console.error("Error checking role:", error);
        setUserRole(false);
      }
    };

    checkRole();
  }, [user, loading]);

  if (loading || userRole === null) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  // No access
  if (!userRole) {
    return <Navigate to="/login" replace />;
  }

  // RPC role is limited to the SMM racepack collection desk - no dashboard,
  // no participants, no other admin screen. Any other path bounces there.
  const RPC_HOME = "/smm/rpc";
  if (userRole === "rpc" && location.pathname.toLowerCase() !== RPC_HOME) {
    return <Navigate to={RPC_HOME} replace />;
  }

  return <Outlet />;
};
